import styled from 'styled-components'
import { breakpoints } from '../../constants'

export const MainContainer = styled.section`
	margin-top: 0;
	display: flex;
	flex-direction: column;
	align-items: center;

	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-top: -120px;
	}

	.trip-search-section-muvibus {
		margin-top: -3rem;
		@media (max-width: ${breakpoints.MOBILE}px) {
			margin-top: 0;
		}
	}
	.banner-container {
		background: #ffb34f;
		width: 100%;
		text-align: center;
		.banner {
			@media (max-width: ${breakpoints.MOBILE}px) {
				display: none;
			}
		}
		.banner-mobile {
			.img-responsive {
				display: block;
				width: 100vw;
			}
			@media (min-width: ${breakpoints.MOBILE}px) {
				display: none;
			}
		}
	}
`
